import script from "./CompanyServiceForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyServiceForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__